import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";

import {BehaviorSubject, Observable, of, tap} from "rxjs";

import {BaseHttpService} from "@shared/services-http/base-http.service";

import {getETollBalanceResponse} from "@layout/vehicle/http-services/responses/getETollBalance.response";
import {getETollBalanceDetailsResponse} from "@layout/vehicle/http-services/responses/getETollBalanceDetails.response";

@Injectable({
  providedIn: 'root'
})
export class EtollStatusHttpService extends BaseHttpService {

  static readonly noEtollDataForVehicleErrorCode = 6;

  isEtollDataAvailableSub = new BehaviorSubject<boolean>(false);

  private cachedBalance?: getETollBalanceResponse;
  private readonly cacheBalanceDetails = new Map<number, getETollBalanceDetailsResponse>();

  constructor(protected httpClient: HttpClient) {
    super();
  }

  getBalance(): Observable<getETollBalanceResponse> {
    if (this.cachedBalance)
      return of(this.getClone(this.cachedBalance));

    const url = this.getUrl('/GetETollBalance');
    return this.httpClient.get<getETollBalanceResponse>(url).pipe(
      tap(response => {
        this.cachedBalance = this.getClone(response);
        const isEtollDataAvailable = response.Result?.Result != null && response.Result?.Result.length > 0;
        this.isEtollDataAvailableSub.next(isEtollDataAvailable);
      }));
  }

  getBalanceDetails(vehicleId: number): Observable<getETollBalanceDetailsResponse> {
    const cached = this.cacheBalanceDetails.get(vehicleId);
    if (cached)
      return of(this.getClone(cached));

    const url = this.getUrl('/GetETollBalanceDetails/' + vehicleId);
    return this.httpClient.get<getETollBalanceDetailsResponse>(url).pipe(
      tap(response => {
        this.cacheBalanceDetails.set(vehicleId, this.getClone(response));
      }));
  }
}
